(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function formatProductMoney(cents, currency) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'AUD' }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function syncProductForm(section) {
    var select = section.querySelector('[data-ct-variant-select]');
    var option = select ? select.options[select.selectedIndex] : null;
    var submit = section.querySelector('[data-ct-product-submit]');
    var label = section.querySelector('[data-ct-product-submit-label]');
    var quantityInput = section.querySelector('[data-ct-quantity-input]');
    var note = section.querySelector('[data-ct-variant-note]');
    var priceMeta = section.querySelector('[data-ct-product-price-meta]');
    if (!option || !submit || !label) return;

    var available = option.getAttribute('data-available') === 'true';
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var priceCents = parseInt(option.getAttribute('data-price-cents'), 10) || 0;
    var currency = section.getAttribute('data-currency') || 'AUD';

    submit.disabled = !available;
    label.textContent = available
      ? submit.getAttribute('data-add-label') + ' · ' + formatProductMoney(priceCents * quantity, currency) + ' →'
      : submit.getAttribute('data-sold-out-label');

    if (priceMeta && option.getAttribute('data-price-meta')) {
      priceMeta.textContent = option.getAttribute('data-price-meta');
    }

    if (note) {
      var savePercent = parseInt(option.getAttribute('data-save-percent'), 10) || 0;
      if (savePercent > 0) {
        note.textContent = 'You save ' + option.getAttribute('data-save-amount') + ' · just ' + option.getAttribute('data-unit-price') + '/bag';
        note.classList.add('is-saving');
      } else {
        note.textContent = note.getAttribute('data-default-note') || '';
        note.classList.remove('is-saving');
      }
    }
  }

  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-ct-product-thumb]');
    if (thumb) {
      var section = thumb.closest('[data-ct-product-section]');
      var image = section ? section.querySelector('[data-ct-product-main-image]') : null;
      if (!image) return;
      image.src = thumb.getAttribute('data-image-src');
      image.srcset = thumb.getAttribute('data-image-srcset');
      image.alt = thumb.getAttribute('data-image-alt') || image.alt;
      section.querySelectorAll('[data-ct-product-thumb]').forEach(function(button) {
        button.classList.toggle('is-active', button === thumb);
      });
      return;
    }

    var minus = event.target.closest('[data-ct-quantity-minus]');
    var plus = event.target.closest('[data-ct-quantity-plus]');
    if (!minus && !plus) return;

    var quantity = event.target.closest('[data-ct-quantity]');
    var input = quantity ? quantity.querySelector('[data-ct-quantity-input]') : null;
    if (!input) return;

    var value = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, value + (plus ? 1 : -1));

    var section = input.closest('[data-ct-product-section]');
    if (section) syncProductForm(section);
  });

  document.addEventListener('change', function(event) {
    var jump = event.target.closest('[data-ct-product-jump]');
    if (jump && jump.value) {
      window.location.href = jump.value;
      return;
    }

    var select = event.target.closest('[data-ct-variant-select]');
    if (!select) return;

    var section = select.closest('[data-ct-product-section]');
    var option = select.options[select.selectedIndex];
    var input = section.querySelector('[data-ct-variant-input]');
    var price = section.querySelector('[data-ct-product-price]');
    var compare = section.querySelector('[data-ct-product-compare-price]');

    input.value = option.value;
    price.textContent = option.getAttribute('data-price');

    if (option.getAttribute('data-compare-price')) {
      compare.textContent = option.getAttribute('data-compare-price');
      compare.hidden = false;
    } else {
      compare.textContent = '';
      compare.hidden = true;
    }

    syncProductForm(section);
  });

  document.addEventListener('input', function(event) {
    var quantityInput = event.target.closest('[data-ct-quantity-input]');
    if (!quantityInput) return;

    var section = quantityInput.closest('[data-ct-product-section]');
    if (section) syncProductForm(section);
  });

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('[data-ct-product-form]');
    if (!form) return;

    var variantInput = form.querySelector('[data-ct-variant-input]');
    var quantityInput = form.querySelector('[data-ct-quantity-input]');
    var variantId = variantInput ? variantInput.value : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    if (!variantId || !window.cartDrawer) return;

    event.preventDefault();
    window.cartDrawer.addItem(variantId, quantity);
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-ct-product-section]').forEach(syncProductForm);
  });

  } catch(e) { console.error(e); }
})();
})();
